// Polyfill for process (fixes 'process is not defined' error in modern build environments)
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
    window.process = { 
        env: { 
            NODE_ENV: typeof window !== 'undefined' && window.location && window.location.hostname === 'localhost' ? 'development' : 'production' 
        } 
    };
}
